import { loadTemplate } from "utils/load_template"
import SelectRefinementWidget from 'components/algolia/select_refinement_widget'
import DistinctRefinementWidget from 'components/algolia/distinct_refinement_widget'

export function nestedCreditTypesMobileWidget(jurisdictionName = null) {
  return new SelectRefinementWidget({
    selectType: "single",
    connector: instantsearch.connectors.connectHierarchicalMenu
  }).widget({
    attributes: [
      'credit_types_per_jurisdiction.lvl0',
      'credit_types_per_jurisdiction.lvl1'
    ],
    transformItems(items) {
      return items.map(item => ({
        ...item,
        label: `${item.label} (${item.count})`,
        data: item.data ? item.data.map((child) => ({
          ...child,
          label: `${child.label} (${child.count})`
        })) : null
      }))
    },
    limit: 500,
    container: "credit_types_per_jurisdiction_mobile",
    rootPath: jurisdictionName,
    sortBy: ["isRefined", "name:asc"]
  })
}

export function nestedCreditTypesWidget(jurisdictionName = null) {
  return instantsearch.widgets.hierarchicalMenu({
    container: '#credit_types_per_jurisdiction',
    limit: 500,
    attributes: [
      'credit_types_per_jurisdiction.lvl0',
      'credit_types_per_jurisdiction.lvl1'
    ],
    transformItems(items) {
      return items.map(item => ({
        ...item,
        level: (item.data === null ? '2' : '1')
      }))
    },
    templates: {
      item: loadTemplate("cle_jurisdiction_credit_type_filter_template")
    },
    cssClasses: {
      root: "scrollable"
    },
    sortBy: ["isRefined", "name:asc"],
    rootPath: jurisdictionName
  })
}

export function creditTypesWidget({ showCounters }) {
  return new DistinctRefinementWidget({
    connector: instantsearch.connectors.connectRefinementList,
    showCounters: showCounters,
    facetCounterAttribute: "credit_types_jurisdictions",
    facetCounterComparisonFn: (credit_types_jurisdictions, facetValue, facetFilters) => {
      // If this course is outdated in Algolia we return false
      if (credit_types_jurisdictions !== null && credit_types_jurisdictions !== undefined) {
        const jurisdictionsFilters = facetFilters.flat().filter((item) => item.match(/jurisdictions:/)).map((item) => item.split(":")[1])
        const creditTypeKey = facetValue.replaceAll(" ", "")

        // If user selected one or more jurisdictions we count the credit types which have those jurisdictions
        if (jurisdictionsFilters.length > 0) {
          let matches = 0

          jurisdictionsFilters.forEach(element => {
            matches += (credit_types_jurisdictions[creditTypeKey] || []).indexOf(element) >= 0 ? 1 : 0
          })

          return matches > 0
        } else {
          return Object.keys(credit_types_jurisdictions).indexOf(creditTypeKey) >= 0
        }
      } else {
        return false
      }
    }
  }).widget({
    attribute: "credit_types",
    limit: 500,
    operator: "or",
    container: "credit_types",
    templates: {
      item: loadTemplate(showCounters ? "cle_credit_types_filter_template_with_counters" : "cle_credit_types_filter_template")
    },
    cssClasses: {
      root: "scrollable"
    },
    sortBy: ["name:asc"]
  })
}

export function creditTypesMobileWidget() {
  return new SelectRefinementWidget({ selectType: "multiple" }).widget({
    attribute: "credit_types",
    limit: 500,
    container: "credit_types_mobile",
    sortBy: ["name:asc"]
  })
}
